import React, { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { Paper, Box, Button, Typography, TextField, Divider, Table, TableHead, TableBody, TableCell, TableRow, Autocomplete } from '@mui/material';
import { ApolloClient, ApolloProvider, gql, InMemoryCache, useMutation, useQuery } from "@apollo/client";
import { Modal } from "./modal";
import { GitGraph } from "./git-graph";

const client = new ApolloClient({
  uri: localStorage.getItem('HEXHIVE_API') || 'http://localhost:7030/graphql',
  credentials: 'include',
  cache: new InMemoryCache()
})

export default function Root(props){
  return (
    <ApolloProvider client={client}>
      <RootWrapped {...props} />
    </ApolloProvider>
  )
}

function RootWrapped(props) {

    const { data } = useQuery(gql`
        query {
            history {
                committer
                commit_hash
                message
                date
            }    
        }
    `)
    const chart = `gitGraph LR:
        ${(data?.history || []).slice()?.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()).map((item) => `commit id: "${item.message}"`).join('\n')}
       `
      return data?.history && <GitGraph chart={chart}/>
}


/*
commit id: "1"
       commit id: "2"
       branch nice_feature
       checkout nice_feature
       commit id: "3"
       checkout main
       commit id: "4"
       checkout nice_feature
       branch very_nice_feature
       checkout very_nice_feature
       commit id: "5"
       checkout main
       commit id: "6"
       checkout nice_feature
       commit id: "7"
       checkout main
       merge nice_feature id: "customID" tag: "customTag" type: REVERSE
       checkout very_nice_feature
       commit id: "8"
       checkout main
       commit id: "9"
*/
